import { Component, OnInit } from '@angular/core';
import { TreeviewItem } from 'ngx-treeview';
import { Proizvodjac } from './proizvodjac';
import { ModalContainerService
  , ModalService
  , BaseDataService
  , BaseContainerService
  , BaseModalContainer
  , UserService
} from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { ConvItems2Treeviewitem } from 'src/app/core/classes/conv-items2-treeviewitem';

@Component({
  selector: 'yt-proizvodjac',
  templateUrl: './proizvodjac.component.html'
})
export class ProizvodjacComponent
extends BaseModalContainer<Proizvodjac>
  implements OnInit {

  list: TreeviewItem[];
  config= {  hasAllCheckBox: false,
    hasFilter: true,
    hasCollapseExpand: false,
    decoupleChildFromParent: true,
    maxHeight: 500
  };

  constructor(
    protected modalContainerService: ModalContainerService<Proizvodjac>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService
    , protected userService: UserService

    // , protected baseDataService: BaseDataService,
    // protected baseContainerService:BaseContainerService<Proizvodjac>
    // , protected convItems2Tree: ConvItems2Treeviewitem
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);

  }

  ngOnInit() {
  }

}
